<template>
  <div class="images">
    <div class="image" v-for="image in images" :key="image.src">
      <img v-lazy="image.src" :alt="image.title || app_name()" />
      <p class="mb-0" v-if="image.title" v-text="image.title"></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.images {
  --size: 92px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--size), 1fr));
  grid-gap: 0.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  .image {
    img {
      width: 100%;
      height: calc(var(--size) * 0.8);
      object-fit: contain;
      border-radius: var(--border-radius);
      border: 1px solid var(--light);
    }
    p {
      font-size: 0.7rem;
      text-align: center;
      opacity: 0.7;
    }
  }
}
</style>